import { useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { App } from 'lmcv/components/App'
import { Card, CardHeader } from 'lmcv/components/Card'
import { Actions as UserActions } from 'lmcv/redux/modules/user'
import { Actions as NotificationActions } from 'lmcv/redux/modules/notification'

import RoutesMiddleware from './RoutesMiddleware'

function RenderRoutes ({ routes, noMatch }) {
  const dispatch = useDispatch()
  const { get } = useSelector(state => state.user)

  useEffect(() => {
    dispatch(UserActions.get())
  }, [dispatch])

  useEffect(() => {
    if (!get.isRequest) {
      dispatch(NotificationActions.get())
    }
  }, [dispatch, get.isRequest])

  if (get.isRequest) {
    return ''
  }

  return (
    <BrowserRouter basename="/fidelidade">
      <App>
        <Switch>
          {routes.map(route => (
            <RoutesMiddleware key={route.key} {...route} />
          ))}
          <Route component={noMatch} />
        </Switch>
      </App>
    </BrowserRouter>
  )
}

RenderRoutes.defaultProps = {
  noMatch: () => (
    <Card>
      <CardHeader
        title="Não encontramos a página solicitada"
        text="Verifique se a URL está correta e tente novamente."
      />
    </Card>
  )
}

export default RenderRoutes
